var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.498535,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F1ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1817_11086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 18.4985H24V20.4985H26V26.4985H14V20.4985H15V18.4985H13C12.4 18.4985 12 18.8985 12 19.4985V27.4985C12 28.0985 12.4 28.4985 13 28.4985H27C27.6 28.4985 28 28.0985 28 27.4985V19.4985C28 18.8985 27.6 18.4985 27 18.4985Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20.4985H19C19.3 20.4985 19.5 20.3985 19.7 20.1985L24.7 15.1985C25.1 14.7985 25.1 14.1985 24.7 13.7985L23.7 12.7985C23.3 12.3985 22.7 12.3985 22.3 12.7985L17.3 17.7985C17.1 17.9985 17 18.1985 17 18.4985V20.4985Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 22.4985H16V24.4985H24V22.4985Z",
    fill: "#9C82FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1817_11086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.4985)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanIcon);
export default __webpack_public_path__ + "static/media/plan-icon.3552a3310976f5418ba09352cfa28934.svg";
export { ForwardRef as ReactComponent };